export default "__VITE_ASSET__DCrUmcaI__"